export const storeUser = (user) => ({
    type: 'STORE_USER',
    user
});

export const storeToken = (token) => ({
    type: 'STORE_TOKEN',
    token
});